<template>
  <div class="container">
    <i
      class="lni lni-files text-black-50 pointer"
      v-clipboard:copy="text"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError"
    ></i>
  </div>
</template>
 
<script>
export default {
  props: ["text"],

  methods: {
    onCopy: function () {
      this.$root.$bvToast.toast("Success", {
        title: "Copied",
        autoHideDelay: 250,
        variant: "success",
      });
    },
    onError: function () {
      this.$root.$bvToast.toast("Error", {
        title: "Not Copied",
        autoHideDelay: 1000,
        variant: "danger",
      });
    },
  },
};
</script> 